import React, { HTMLAttributes } from 'react'
import cx from 'classnames'

import List from '../../List'

import { BasicOption, OptionProps } from './interfaces'

import cm from './OptionsList.module.css'
export const Option = <OptionType extends BasicOption>({
  option,
  focused,
  selected,
  renderOption,
  handleSelect,
  setFocusedId,
}: OptionProps<OptionType>) => {
  const optionProps: HTMLAttributes<HTMLElement> = {
    onMouseEnter: () => setFocusedId(option.id),
    onMouseLeave: () => setFocusedId(undefined),
    onClick: () => handleSelect(option),
    role: 'menuitem',
    className: cx(cm.listItem, focused && !selected && cm.focused),
  }

  if (renderOption) {
    return renderOption(option, { focused, selected }, optionProps)
  }
  if (option.type === 'group') {
    return <List.GroupHeading key={option.label} {...option} />
  }

  return <List.Item {...option} selected={selected} {...optionProps} />
}
